import Vue from 'vue'
import Router from 'vue-router'
import Head from '@/components/pc/public/Head'
import Foot from '@/components/pc/public/Foot'
// import Home from '@/components/pc/home/Home'
// import AboutUs from '@/components/pc/AboutUs/AboutUs'
// import ShortVideoMarketing from '@/components/pc/ShortVideoMarketing/ShortVideoMarketing'
// import WhLiveBroadcast from '@/components/pc/WhLiveBroadcast/WhLiveBroadcast'
// import BusinessCooperation from '@/components/pc/BusinessCooperation/BusinessCooperation'


Vue.use(Router)

export default new Router({
  mode :"history",//除去#号
  routes: [
    {
      path: '/',
      name: 'home',
      components: {
        head: Head,
        foot: Foot,
        content: () => import('@/components/pc/home/Home')
      }
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      components: {
        head: Head,
        foot: Foot,
        content: () => import('@/components/pc/AboutUs/AboutUs')
      }
    },
    {
      path: '/shortVideoMarketing',
      name: 'shortVideoMarketing',
      components: {
        head: Head,
        foot: Foot,
        content: () => import('@/components/pc/ShortVideoMarketing/ShortVideoMarketing')
      }
    },
    {
      path: '/whLiveBroadcast',
      name: 'whLiveBroadcast',
      components: {
        head: Head,
        foot: Foot,
        content: () => import('@/components/pc/WhLiveBroadcast/WhLiveBroadcast')
      }
    },
    {
      path: '/businessCooperation',
      name: 'businessCooperation',
      components: {
        head: Head,
        foot: Foot,
        content: () => import('@/components/pc/BusinessCooperation/BusinessCooperation')
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js